// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"TrelloListSelector_submitBtn__1ZQSS","progress":"TrelloListSelector_progress__1dqQe"};